import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { PageTitle } from "../models/models";

@Injectable({
  providedIn: "root"
})
export class HeaderService {
  private _pageTitleSource = new BehaviorSubject<PageTitle>({} as PageTitle);
  pageTitle$ = this._pageTitleSource.asObservable();

  constructor() { }

  setPageTitle(showChipsCount: boolean, chipsCount: number, pageTitleText: string) {
    let pageTitle = {} as PageTitle;
    pageTitle.showChipsCount = showChipsCount;
    pageTitle.chipsCount = chipsCount;
    pageTitle.pageTitleText = pageTitleText;
    this._pageTitleSource.next(pageTitle);
  }
}  
